var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useTransScale)?_c('div',{class:("good-tag-" + _vm.refId + " good-tag"),style:(Object.assign({}, {'background-color': !_vm.hasBackground
      ? 'none'
      : _vm.bgColor.length
      ? _vm.bgColor
      : _vm.secondaryColor.length
      ? _vm.secondaryColor
      : 'none',
    border:
      _vm.hasBorder && _vm.secondaryColor.length
        ? ("1px solid " + _vm.secondaryColor)
        : 'none',
    'border-radius': ((_vm.cornerRadius * 2) + "px"),
    transform: ("scale(" + _vm.transScale + ")")},
    _vm.tagStyle))},[_c('span',{style:({ color: _vm.primaryColor, fontSize: ((_vm.fontSize * 2) + "px") })},[_vm._t("default")],2)]):_c('div',{class:[
    'tag',
    {
      'has-margin': _vm.hasMargin,
      'no-bottom': _vm.noBottomMargin
    }
  ],style:(Object.assign({}, {'background-color': !_vm.hasBackground
      ? 'none'
      : _vm.bgColor.length
      ? _vm.bgColor
      : _vm.secondaryColor.length
      ? _vm.secondaryColor
      : 'none',
    border:
      _vm.hasBorder && _vm.secondaryColor.length
        ? ("1px solid " + _vm.secondaryColor)
        : 'none',
    'border-radius': (_vm.cornerRadius + "px"),
    padding: (_vm.paddingTopBottom + "px " + _vm.paddingLeftRight + "px")},
    _vm.tagStyle))},[_c('span',{class:['tag-text', _vm.textEllipsis ? 'text-ellipsis' : ''],style:({
      color: _vm.primaryColor,
      fontSize: (_vm.fontSize + "px"),
      fontWeight: _vm.bold ? 'bold' : ''
    })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }